/* ==========================================================================
   VASUMATIS — card action feedback  ·  v3

   THREE ATTEMPTS, AND WHY THE FIRST TWO FAILED. Worth keeping, because each
   failure was a wrong assumption about the theme rather than a typo.

   v1 · bag — watched #CartCount for a change.
        Measured on the live page: the badge never changes on an add from a
        collection card, so there was nothing to observe. (That is a real bug
        in the theme, fixed at the bottom of this file.)

   v2 · bag — wrapped window.fetch to read the /cart/add response.
        Also dead. This file loads from <head>; Shopify's own analytics script
        loads afterwards and REPLACES window.fetch with its own wrapper, which
        captured the native fetch before we patched it. By the first click,
        String(window.fetch) reads
            function(n,r){ … return e.ga4FeFal…
        Our patch was simply gone. No load-order tweak makes patching a global
        that Shopify also patches a safe thing to do.

   v3 · bag — asks the cart. On tap it polls /cart.js until item_count rises.
        Nothing to clobber, no dependence on theme internals, no event names,
        no markup assumptions. It also hands back the true count, so the header
        badge can be set from fact rather than inferred.

   v1 · wishlist — waited for a class `added` / `is-active` on .addto-wishlist.
        Avone REMOVES .addto-wishlist at the moment of saving:
            $('.wishlist[rel="'+id+'"]').removeClass("addto-wishlist")
            $('.wishlist[rel="'+id+'"] .at').addClass("at-heart")
        so the compound selector could never match. The real signal is the
        inner <i> swapping at-heart-l -> at-heart, 1500ms after the tap. That
        part has worked since v2 and is unchanged here.

   The celebration never fires on the click. A sold-out variant, a rejected
   line item or a dead connection gets the grey flash, not gold flecks.
   ========================================================================== */

(function () {
  'use strict';

  var ADDED_MS    = 1500;   // how long the filled bag holds
  var FAILED_MS   = 1200;   // how long the grey flash holds
  var POLL_MS     = 350;    // gap between /cart.js checks
  var POLL_LIMIT  = 7000;   // give up after this and show failure

  // Captured before anything else can wrap it. Used for our own polling so we
  // never appear in Shopify's analytics timings.
  var rawFetch = window.__vasRawFetch
              || (window.fetch && window.fetch.bind(window));

  var pending   = null;
  var baseline  = null;     // last known item_count
  var pollTimer = null;
  var pollStart = 0;

  function getCount() {
    if (!rawFetch) return Promise.reject();
    return rawFetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (r) { return r.json(); })
      .then(function (c) { return c && typeof c.item_count === 'number' ? c.item_count : null; });
  }

  function stopPolling() {
    if (pollTimer) { clearTimeout(pollTimer); pollTimer = null; }
    pending = null;
  }

  function bagFail() {
    if (!pending) return;
    var el = pending;
    stopPolling();
    el.classList.remove('is-added');
    el.classList.add('is-failed');
    setTimeout(function () { el.classList.remove('is-failed'); }, FAILED_MS);
  }

  function bagSucceed(count) {
    var el = pending;
    stopPolling();
    setCartBadge(count);
    if (!el) return;
    el.classList.remove('is-failed', 'is-added');
    void el.offsetWidth;                     // restart the animation cleanly
    el.classList.add('is-added');
    setTimeout(function () { el.classList.remove('is-added'); }, ADDED_MS);
  }

  /* ======================================================================
     THE HEADER CART BADGE
     Avone has a working updater, freeShippMsg(), which refreshes both
     #CartCount and the free-shipping message. It is called from exactly one
     place in theme.js — CartItems.updateLiveRegions() — which only runs when
     a QUANTITY changes on the cart page or in the drawer. Nothing calls it
     after /cart/add, so the badge sits at its old value until the next page
     load, and a customer who taps again ends up with two in the cart.

     We write the number ourselves (we already have the true count, so this
     cannot be wrong) and then let the theme's own function run for the
     free-shipping message, which was going stale for the same reason.
     ====================================================================== */
  function setCartBadge(count) {
    if (typeof count === 'number') {
      var badge = document.getElementById('CartCount');
      if (badge) badge.textContent = count;
    }
    if (typeof window.freeShippMsg === 'function') {
      try { window.freeShippMsg(); } catch (err) { /* not fatal */ }
    }
  }

  /* ======================================================================
     1 · BAG — on tap, start asking the cart
     ====================================================================== */
  function poll() {
    if (!pending) return;
    if (Date.now() - pollStart > POLL_LIMIT) { bagFail(); return; }
    getCount().then(function (n) {
      if (!pending) return;
      if (n !== null && baseline !== null && n > baseline) {
        baseline = n;
        bagSucceed(n);
      } else {
        if (n !== null && baseline === null) baseline = n;
        pollTimer = setTimeout(poll, POLL_MS);
      }
    }).catch(function () {
      if (pending) pollTimer = setTimeout(poll, POLL_MS);
    });
  }

  document.addEventListener('click', function (e) {
    var bag = e.target.closest && e.target.closest('.vas-bag.add-to-cart');
    if (!bag) return;
    stopPolling();
    pending   = bag;
    pollStart = Date.now();
    pollTimer = setTimeout(poll, POLL_MS);
  }, true);

  // baseline on load, and keep it honest if the cart changes elsewhere
  getCount().then(function (n) { if (baseline === null) baseline = n; }).catch(function () {});
  window.addEventListener('pageshow', function () {
    if (pending) return;
    getCount().then(function (n) { baseline = n; }).catch(function () {});
  });

  /* ======================================================================
     2 · WISHLIST — pending pulse on tap
     Avone waits 1500ms before marking the item saved, so without this the
     heart looks dead for a second and a half.
     ====================================================================== */
  document.addEventListener('click', function (e) {
    var fav = e.target.closest && e.target.closest('.grid-view-item .btn.wishlist');
    if (!fav || fav.classList.contains('vas-saved')) return;
    fav.classList.add('vas-pending');
  }, true);

  /* ======================================================================
     3 · WISHLIST — the real signal: <i> goes at-heart-l -> at-heart
     ====================================================================== */
  function markSaved(fav, animate) {
    if (!fav || fav.classList.contains('vas-saved')) return;
    fav.classList.remove('vas-pending');
    fav.classList.add('vas-saved');
    if (!animate) return;
    fav.classList.remove('vas-pop');
    void fav.offsetWidth;
    fav.classList.add('vas-pop');
  }

  function scan(animate) {
    document.querySelectorAll('.grid-view-item .btn.wishlist').forEach(function (fav) {
      var i = fav.querySelector('i');
      if (i && i.classList.contains('at-heart')) markSaved(fav, animate);
    });
  }

  scan(false);                                     // items already saved in localStorage
  document.addEventListener('DOMContentLoaded', function () { scan(false); });
  window.addEventListener('load', function () { scan(false); });

  new MutationObserver(function (records) {
    for (var n = 0; n < records.length; n++) {
      var t = records[n].target;
      if (!t.classList || t.tagName !== 'I') continue;
      if (!t.classList.contains('at-heart')) continue;
      var fav = t.closest('.grid-view-item .btn.wishlist');
      if (fav) markSaved(fav, true);
    }
  }).observe(document.documentElement, {
    subtree: true, attributes: true, attributeFilter: ['class']
  });

  /* ======================================================================
     4 · let the heart pop replay next time
     ====================================================================== */
  document.addEventListener('animationend', function (e) {
    if (e.animationName !== 'vasHeartPop') return;
    var btn = e.target.closest && e.target.closest('.btn.wishlist');
    if (btn) btn.classList.remove('vas-pop');
  }, true);

})();